export default __webpack_public_path__ + "static/media/CarImages.SorentoGallery5.da109e14.jpg";